var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSa(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 24,
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_306_1348",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 24,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_306_1348)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H32V24H0V0Z",
    fill: "#F5FBFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0V8H32V0H0Z",
    fill: "#E31C1C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 16V24H32V16H0Z",
    fill: "#3D57DB"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-5-outside-1_306_1348",
    maskUnits: "userSpaceOnUse",
    x: -2,
    y: -7,
    width: 36,
    height: 38,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: -2,
    y: -7,
    width: 36,
    height: 38
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4286 10L0 -2V26L15.4286 14H32V10H15.4286Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4286 10L0 -2V26L15.4286 14H32V10H15.4286Z",
    fill: "#5DA923"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -2L1.22788 -3.5787L-2 -6.08928V-2H0ZM15.4286 10L14.2007 11.5787L14.7424 12H15.4286V10ZM0 26H-2V30.0893L1.22788 27.5787L0 26ZM15.4286 14V12H14.7424L14.2007 12.4213L15.4286 14ZM32 14V16H34V14H32ZM32 10H34V8H32V10ZM-1.22788 -0.421296L14.2007 11.5787L16.6565 8.4213L1.22788 -3.5787L-1.22788 -0.421296ZM2 26V-2H-2V26H2ZM14.2007 12.4213L-1.22788 24.4213L1.22788 27.5787L16.6565 15.5787L14.2007 12.4213ZM32 12H15.4286V16H32V12ZM30 10V14H34V10H30ZM15.4286 12H32V8H15.4286V12Z",
    fill: "#FAFDFF",
    mask: "url(#path-5-outside-1_306_1348)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.6 5.2L-1 4V6V18V20L0.6 18.8L8.6 12.8L9.66667 12L8.6 11.2L0.6 5.2Z",
    fill: "#262626",
    stroke: "#FFCC00",
    strokeWidth: 2
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSa);
export default __webpack_public_path__ + "static/media/SA.c03f662640d8decfb6929c48c697284b.svg";
export { ForwardRef as ReactComponent };